import React from 'react';
import { useSelector } from 'react-redux';
import Select from 'react-select';
import { OutgoingState, IncomingState, Direction, InteractionType, } from '@debbie/common/dist/interactions/index.js';
import { c } from '@debbie/cortex/dist/index.js';
import { Checkbox } from '../..//index.js';
import FilterGroup from '../FilterGroup.js';
import FilterOption from '../FilterOption.js';
let tId;
const InteractionsGroup = (props) => {
    const lang = useSelector((s) => s.lang);
    const { caseFilter } = props;
    return (React.createElement(FilterGroup, { name: lang.caseFilter.interactionsGroup },
        React.createElement(FilterOption, { active: !!(caseFilter.interactionTypes && caseFilter.interactionTypes.length), header: lang.caseFilter.interactionType, onDeactivate: () => c.insights.clearFilter('interactionTypes') },
            React.createElement(Select, { value: (caseFilter.interactionTypes || []).map((interactionType) => ({
                    label: `${lang.interactionTypes[interactionType] || ''} (${interactionType})`,
                    value: interactionType,
                })), isMulti: true, placeholder: lang.caseFilter.selectInteractionType, classNamePrefix: "select", options: Object.values(InteractionType).map((entry) => ({
                    label: `${lang.interactionTypes[entry] || ''} (${entry})`,
                    value: entry,
                })), onChange: async (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        interactionTypes: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!(caseFilter.interactionStates && caseFilter.interactionStates.length), header: lang.caseFilter.interactionState, subheader: lang.caseFilter.doNotHaveFollowingStatusSub, onDeactivate: () => c.insights.clearFilter('interactionStates') },
            React.createElement(Select, { value: (caseFilter.interactionStates || []).map((interactionState) => ({
                    label: lang.interactions[interactionState],
                    value: interactionState,
                })), isMulti: true, placeholder: lang.caseFilter.selectInteractionState, classNamePrefix: "select", options: []
                    .concat(Object.values(OutgoingState))
                    .concat(Object.values(IncomingState))
                    .map((entry) => ({
                    label: lang.interactions[entry],
                    value: entry,
                })), onChange: async (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        interactionStates: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: !!(caseFilter.interactionDirections &&
                caseFilter.interactionDirections.length), header: lang.caseFilter.interactionDirection, onDeactivate: () => c.insights.clearFilter('interactionDirections') },
            React.createElement(Select, { value: (caseFilter.interactionDirections || []).map((interactionDirection) => ({
                    label: lang.interactions[interactionDirection],
                    value: interactionDirection,
                })), isMulti: true, placeholder: lang.caseFilter.selectInteractionDirection, classNamePrefix: "select", options: Object.values(Direction).map((entry) => ({
                    label: lang.interactions[entry],
                    value: entry,
                })), onChange: async (val) => {
                    const selected = val ? val.map((v) => v.value) : [];
                    c.insights.updateFilter({
                        interactionDirections: selected,
                    });
                } })),
        React.createElement(FilterOption, { active: typeof caseFilter.noneOfTheAboveInteractions === 'boolean', header: lang.caseFilter.noneOfTheAbove, onDeactivate: () => c.insights.clearFilter('noneOfTheAboveInteractions') },
            React.createElement(Checkbox, { style: { marginBottom: '0' }, checked: caseFilter.noneOfTheAboveInteractions, onChange: (e) => {
                    if (e.target.checked) {
                        c.insights.updateFilter({
                            noneOfTheAboveInteractions: true,
                        });
                        return;
                    }
                    c.insights.clearFilter('noneOfTheAboveInteractions');
                } }))));
};
export default InteractionsGroup;
//# sourceMappingURL=InteractionsGroup.js.map